/**
 * Keep in sync with BE constants in:
 * benchling/chemistry/schema/core/constants.py
 */
export const MOLECULE_LOT_SCHEMA_INTERFACE_ID = 'ssi_moleculelot';
export const MOLECULE_LOT_DISPLAY_NAME = 'Molecule Lot';

export const MOLECULE_LOT_FIELD_NAMES = {
  MOLECULE_LINK: {displayName: 'Molecule', systemName: 'molecule'},
  PURITY: {displayName: 'Purity', systemName: 'purity'},
  CONCENTRATION_MOLAR: {displayName: 'Concentration (molar)', systemName: 'concentration_molar'},
  CONCENTRATION_DENSITY: {
    displayName: 'Concentration (density)',
    systemName: 'concentration_density',
  },
} as const;
